export default __webpack_public_path__ + "static/media/brand-main-sm.f8abed0b.png";